import { z } from 'zod';

import { UserInterviewSchema } from './user-interview';

export const OpportunityInterviewSchema = UserInterviewSchema.extend({
  collaborators: z.array(z.string().uuid()),
});

export type OpportunityInterview = z.infer<typeof OpportunityInterviewSchema>;
